import ContextMenu from './src/main'

export default ContextMenu



// WEBPACK FOOTER //
// ./src/views/question-review/components/ContextMenu/index.js